import cn from 'classnames';
import React, { useEffect, useReducer } from 'react';
import { useTranslation } from 'react-i18next';

// CSS
import styles from '@UILayer/UILayer.scss';

// REDUX
import { getAccount, getCasinoMenu, getDeviceInfo, getGlobalStyles, setGlobalStyles } from '@Managers/Redux/AppState/AppState';
import { useAppDispatch, useAppSelector } from '@Managers/Redux/Hooks';

// TOOLS
import { CurrencyUtils } from '@Core/Currencies/CurrencyUtils';

// BUTTONS
import { WalletButton } from '@UILayer/Buttons';

import TextField from '@UILayer/Inputs/TextField/TextField';
import { DOM_ID } from '@UILayer/UILayer.types';

const BalanceInfo: React.FC<{}> = () => {
    const [state, setState] = useReducer((state: { balance: number }, newState: any) => ({ ...state, ...newState }), { balance: 0 });

    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const device = useAppSelector(getDeviceInfo);
    const globalStyles = useAppSelector(getGlobalStyles);
    const gameStoreAccount = useAppSelector(getAccount);
    const casinoData = useAppSelector(getCasinoMenu);

    const infoCN = cn(
        styles.infoGroup,
        styles.balanceInfo_container,
        globalStyles.screenSize,
        globalStyles.wcaMode,
        globalStyles.orientation,
        globalStyles.device,
        globalStyles.isTablet
    );

    useEffect(() => {
        const balance = gameStoreAccount.balance.raw;
        if (balance >= 0) setState({ balance: balance });
    }, [gameStoreAccount.balance.raw]);

    function setBalanceFontSize(value: number) {
        dispatch(setGlobalStyles({ balanceFontSize: value }));
    }

    return (
        <>
            <div className={infoCN}>
                {casinoData.cashier?.active && (
                    <div className={cn(styles.button_item, styles.balanceWallet)}>
                        <WalletButton />
                    </div>
                )}

                <div
                    tabIndex={0}
                    aria-description={`${t('BALANCE')} ${state.balance}`}
                    aria-valuetext={JSON.stringify(state.balance)}
                    className={styles.text_item}
                >
                    {device.windowOrientationHorizontal && (
                        <div
                            className={styles.group_label}
                            id={DOM_ID.BALANCE_LABEL}
                            style={{ fontSize: `${globalStyles.balanceFontSize - globalStyles.balanceFontSize / 4}px` }}
                        >
                            {t('BALANCE')}
                        </div>
                    )}
                    <div className={styles.group_value} id="currentBalanceValue">
                        <TextField ofHeightValue={1.8} onResizeEnd={(value: number) => setBalanceFontSize(value)}>
                            {CurrencyUtils.formatRawCurrencyValue(state.balance)}
                        </TextField>
                    </div>
                </div>
                {device.windowOrientationPortrait && (
                    <div className={styles.group_label} id={DOM_ID.BALANCE_LABEL}>
                        {t('BALANCE')}
                    </div>
                )}
            </div>
        </>
    );
};

export default BalanceInfo;
